import { render, staticRenderFns } from "./vpnDownload.vue?vue&type=template&id=9918cde8&scoped=true"
import script from "./vpnDownload.vue?vue&type=script&lang=js"
export * from "./vpnDownload.vue?vue&type=script&lang=js"
import style0 from "./vpnDownload.vue?vue&type=style&index=0&id=9918cde8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9918cde8",
  null
  
)

export default component.exports